import React from 'react'
import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'



export default function Loading({ 
  size = 'default', 
  color = '#722ed1', 
  text = 'Chargement...', 
  fullScreen = false 
}) {
  const antIcon = <LoadingOutlined style={{ fontSize: size === 'small' ? 24 : size === 'large' ? 40 : 32 }} spin />

  const content = (
    <div className={`flex flex-col items-center justify-center ${fullScreen ? 'h-screen' : 'h-full'}`}>
      <Spin indicator={antIcon} size={size} />
      {text && <p className={`mt-4 text-${size === 'small' ? 'sm' : size === 'large' ? 'lg' : 'base'} text-gray-600`}>{text}</p>}
    </div>
  )

  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-white bg-opacity-80 z-50">
        {content}
      </div>
    )
  }

  return content
}